<template>
  <div class="input">
    <input
      :id="id"
      v-model="data"
      v-bind="$attrs"
      :type="type"
      class="form-control"
      :class="classes"
      :disabled="disabled"
      @input="emitEvent"
      @keydown="emitKeydown"
      @change="emitChange"
      @keyup="checkState"
    />
    <label v-if="isCapsLockOn" class="input__caps-lock-on">
      CapsLock włączony
    </label>
    <label v-if="countChars && charCount" class="input__char-count"
      >Znaków {{ charCount }} / {{ maxChars }}</label
    >
    <label v-if="isAllCaps" class="input__all-caps"
      >Jeśli to możliwe proszę nie pisać wyłącznie wielkimi literami</label
    >
  </div>
</template>

<script>
import BaseControl from "./BaseControl";

export default {
  name: "BaseInput",
  extends: BaseControl,
  props: {
    countChars: {
      type: Boolean,
      default: false
    },
    maxChars: {
      type: Number,
      default: 100
    },
    allowAllCaps: {
      type: Boolean,
      default: false
    },
    allCapsRatio: {
      type: Number,
      default: 0.5
    },
    type: {
      type: String,
      default: "text"
    }
  },
  data() {
    return {
      isCapsLockOn: false
    };
  },
  computed: {
    charCount() {
      return this.value.length;
    },
    isAllCaps() {
      if (this.value && !this.disabled) {
        let lowerCase = this.value.replace(/[^a-z0-9]/g, "").length;
        let length = this.value.length;
        return (
          !this.allowAllCaps &&
          length > 5 &&
          lowerCase / length < this.allCapsRatio
        );
      }
      return "";
    }
  },
  methods: {
    checkState(e) {
      this.isCapsLockOn = !this.allowAllCaps && e.getModifierState("CapsLock");
    }
  }
};
</script>

<style lang="scss">
@import "@/styles/_variables";

.form-control:disabled,
.form-control[readonly] {
  border-color: $col-polmed-gray2;
  background: lighten($col-polmed-gray, 5%);
}
.input {
  &__char-count {
    display: block;
    color: $col-polmed-gray;
    font-size: 0.8em;
    padding-top: 6px;
  }
  &__all-caps {
    display: block;
    color: darken($col-polmed-orange, 5%);
    font-size: 0.8em;
    padding-top: 6px;
  }
  &__caps-lock-on {
    display: block;
    float: right;
    color: darken($col-polmed-orange, 5%);
    font-size: 0.8em;
    padding-top: 6px;
  }
}
</style>
